import React from 'react';
import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/components/capstone/base';
import { ExternalLinkIcon } from '@rsos/assets/icons';
import { trackClickLinkOutButton } from '../SpatialLayers/spatialLayersTrackings';
import { ButtonText } from './MapDialog.styles';

const MenuButtonWrapper = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  justify: 'center',
  py: '2px',
})`
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  justify-content: flex-start;
  align-items: flex-end;
  flex-wrap: wrap;
`;

const DialogButton = styled(Button).attrs(() => ({}))`
  line-height: 1.2;
  padding: 12px;
`;

const TitleBox = styled(Box).attrs({
  p: '4px 9px',
})`
  line-break: anywhere;
`;

const TitleText = styled(Text).attrs({
  fontWeight: 'bold',
  color: 'primaryText',
})``;

const SubTitleText = styled(Text).attrs({
  size: 'small',
  color: 'secondaryText',
})``;
const ButtonBox = styled(Box).attrs({
  pr: '4px',
  ml: '2px',
})`
  align-self: center;
`;
const IconWrapper = styled(Box).attrs({
  color: 'background',
})``;

/**
 * @param {String} buttonText - Text for the button
 * @param {String} buttonText - Text for the button
 * @param {String} buttonText - Text for the button
 * @param {String} buttonText - Text for the button
 */
export const MenuButton = ({
  buttonText,
  deeplink,
  irpVersion,
  source,
  subtitle,
  title,
}) => {
  const handleClick = () => {
    trackClickLinkOutButton(irpVersion, source);
    window.open(deeplink.data.url, '_blank', 'noopener noreferrer');
  };

  return (
    <MenuButtonWrapper>
      <TitleBox grow pl="9px" py="4px">
        <TitleText>{title}</TitleText>
        <SubTitleText>{subtitle}</SubTitleText>
      </TitleBox>
      <ButtonBox width={'70px'}>
        <DialogButton
          btnType="primary"
          size="xsmall"
          name="view-pdf-btn"
          disabled={deeplink.loading || !deeplink?.data?.url}
          onClick={handleClick}
        >
          <ButtonText>{buttonText}</ButtonText>
          <IconWrapper>
            <ExternalLinkIcon width={12} height={12} />
          </IconWrapper>
        </DialogButton>
      </ButtonBox>
    </MenuButtonWrapper>
  );
};
